import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
import {Link} from 'react-scroll';


const Home = () => {
  return (
    <div name= 'home' className='w-full h-screen bg-[#0a192f]'>

       {/* Contianer */}
       <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
        <p className='text-green-300' >Hello, my name is</p>
        <h1 className='text-4xl sm:text-6xl font-bold text-[rgb(204,214,246)]'>Dubard Jones</h1>
        <h2 className='text-4xl sm:text-6xl font-bold text-[#8892b0]'>I am a Front-end Web Developer</h2>
        <p className='text-[#8892b0] py-4 max-w-[700px]'>I am a Frontend Web Developer with interest in creating responsive and innovative web and mobile applications. At the moment, I am currently focused on learning how to build more aesthetic web applications.</p>
        <div>
        <Link  to="work"  smooth={true}  duration={500} >
               <button className=' text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-green-300 hover:border-green-300' >
                View Work 
               <span className='group-hover:rotate-90 duration-300'>
                    <HiArrowNarrowRight className='ml-3' /> 
                     </span>
                    </button>
                    </Link> 
        </div>

    </div>

    </div>
  )
}

export default Home